import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as DropdownIcon } from '../../icons/dropdown-arrow.svg';
import { ReactComponent as BuildingLight } from '../../icons/building-icon-selected-light.svg';
import { ReactComponent as BuildingDark } from '../../icons/building-icon-selected-dark.svg';
import searchIcon from '../../icons/search.svg';
import searchDarkIcon from '../../icons/search-dark.svg';
import { ReactComponent as CancelIcon } from '../../icons/cancel-icon.svg';

import './BuildingDropdown.less';

export const BuildingDropdown = (props) => {
  const { items, filter, placeholder, callback, renderCondition, theme } = props;

  const themedSearch = theme === 'dark' ? searchDarkIcon : searchIcon;

  const [toggleOpen, setToggleOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const dropdownRef = useRef();

  const handleDropdown = (c) => {
    callback(c);
  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value.toLowerCase());
  };

  useEffect(() => {
    const handler = (e) => {
      if (!dropdownRef.current?.contains(e.target)) {
        setToggleOpen(false);
        setSearchValue('');
      }
    };
    /* eslint-disable no-undef */
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return renderCondition ? (
    <div
      className={`building-dropdown cd-building cd-${theme}`}
      onClick={() => {
        setToggleOpen(!toggleOpen);
        setSearchValue('');
      }}
      data-testid="dropdown-button"
      ref={dropdownRef}
    >
      <div className="icon-container">{theme === 'light' ? <BuildingLight /> : <BuildingDark />}</div>

      <div className={`display-item ${filter ? 'active' : ''}`}>{filter || placeholder}</div>

      {toggleOpen ? (
        <div className={`dropdownWrapper cd-wrapper-${theme}`}>
          <div className="dropdownOption cd-search" onClick={(e) => e.stopPropagation()}>
            <div className={`search-container cd-search-${theme}`}>
              <img src={themedSearch} alt="search icon" />

              <input value={searchValue} onChange={(e) => handleSearch(e)} />

              <div onClick={() => setSearchValue('')} className="cancel-icon">
                <CancelIcon color={theme === 'dark' ? '#4a5866' : '#e2e6ea'} className="svg-cancel" />
              </div>
            </div>
          </div>
          <div className="buildingList">
            {items.filter((b) => b.name.toLowerCase().includes(searchValue)).length === 0 ? (
              <div className="bd-no-buildings">No Buildings Found</div>
            ) : (
              items
                .sort((a, b) => a.name.localeCompare(b.name))
                .filter((b) => b.name.toLowerCase().includes(searchValue))
                .map((c, i) => (
                  <div
                    key={`item-${i}`}
                    className={`dropdownOption ${c.name === filter ? 'selected-op' : ''}`}
                    onClick={() => handleDropdown(c)}
                  >
                    {c.name}
                  </div>
                ))
            )}
          </div>
        </div>
      ) : null}

      <div className="arrow-container">
        <DropdownIcon color={!toggleOpen ? '#4A5866' : '#06b2bc'} />
      </div>
    </div>
  ) : (
    <div className={`skeleton_dropdown skeleton_dropdown-${theme}`} data-testid="skeleton_dropdown" />
  );
};
